@if (!loading) {
  <app-provider-header [provider]="provider" />
  <div class="page-container">
    <div class="mt-3"><app-prescriptions [provider]="provider" /></div>
  </div>
} @else {
  <mat-spinner />
}
